// Imports
import styled from 'styled-components/macro';
import selfActions from '../../../redux/self/actions';
import Button from '../../../shareables/foundation/front-end/components/buttons/standard';
import { useAppDispatch } from '../../../shareables/foundation/front-end/redux/hooks';
import Modal from '../../../shareables/front-end/modal';
import modalHelpers from '../../../shareables/front-end/modal/modal-helpers';
import keyValueStorage from '../../../shareables/foundation/front-end/utils/key-value-storage';


// Styled components
const StyledButton = styled(Button)`
	margin-top: 1rem;
`;


// Function component
const AdminControlsModal: React.FC = () => {
	// Use Redux functionality
	const dispatch = useAppDispatch();
	
	
	// Return JSX
	return (
		<Modal identifier='admin-controls' title='Heads up!'>
			<p>
				You’re entering a viewing mode that allows you to see the website without administrative controls. This is
				representative of how someone without administrative privileges would see the pages you look at in this mode. To
				get back to where you can edit the content, click the ‘Re-enter admin mode’ link that will appear in the top
				left.
			</p>
			
			<StyledButton
				type='button'
				color='primary'
				onClick={() => {
					keyValueStorage.setItem('viewing_as_non_admin', 'true');
					dispatch(selfActions.setAdminView(false));
					modalHelpers.close('admin-controls-modal');
				}}
			>
				Got it!
			</StyledButton>
		</Modal>
	);
};

export default AdminControlsModal;
